import {classes} from '@bitstillery/common/lib/utils'
import {Icon, Link} from '@bitstillery/common/components'
import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'

export interface LotAttrs {
    type?: 'default' | 'brand' | 'success' | 'info' | 'warning' | 'danger' | (string & {}) | undefined
    purchase_order_reference?: string
    lot_date?: string | null
    stock_age?: number | null
    tip?: string | null | {(): string}
    warehouse_name?: string | null | undefined
    lot_number?: string | null
    mutation?:
        | {
              reference: string
          }
        | undefined
    key?: string | number
}

export class Lot extends MithrilComponent<LotAttrs> {
    view(vn: m.Vnode<LotAttrs>) {
        if (!vn.attrs.type) {
            vn.attrs.type = 'default'
        }

        return (
            <div className={classes('c-lot', `type-${vn.attrs.type}`)}>
                {vn.attrs.lot_date && (
                    <div className='lot-date'>
                        {vn.attrs.lot_date} {vn.attrs.stock_age && <span>{vn.attrs.stock_age} days</span>}
                    </div>
                )}

                <div className='lot-reference'>
                    {vn.attrs.type !== 'default' && <Icon name='stock' size='s' tip={vn.attrs.tip} type={vn.attrs.type} />}
                    {vn.attrs.warehouse_name && (
                        <div className='lot-warehouse'>
                            {vn.attrs.warehouse_name
                                .split(' ')
                                .map((i) => i[0])
                                .join('')}
                        </div>
                    )}
                    {vn.attrs.warehouse_name && vn.attrs.lot_number && '-'}
                    <div className='lot-number'>
                        {(() => {
                            if (vn.attrs.lot_number) {
                                const stock_url = `/stock/items/list/manage?search=${vn.attrs.lot_number}`.replace(/ /g, '+')
                                return <Link href={stock_url}>{vn.attrs.lot_number}</Link>
                            } else if (vn.attrs.mutation) {
                                const {reference} = vn.attrs.mutation
                                return (
                                    <Icon
                                        name='plane'
                                        size='s'
                                        tip={() => {
                                            return `Part of <a href='/stock/mutations/manage/${reference}' target='_blank'>mutation ${reference}</a>`
                                        }}
                                        type='info'
                                    />
                                )
                            } else {
                                return (
                                    <Icon
                                        name='cart'
                                        size='s'
                                        tip={() => {
                                            const reference = vn.attrs.purchase_order_reference
                                            return reference
                                                ? `This is a purchase order item: ${reference}`
                                                : 'This is a purchase order item'
                                        }}
                                        type='info'
                                    />
                                )
                            }
                        })()}
                    </div>
                </div>
            </div>
        )
    }
}
